export const PROVIDER_SET_INTENTIONS_KEY = 'provider-set-intentions';
export const INTENTION_V1_KEY = 'intention-v1';
